import Tabs from 'Components/Element/Tabs';
import React, { useState } from 'react'
import SubTemplate from './SubTemplate';


function  Template({content, activeTab, assistantScreen = false, setActiveTab, tabs, panelItems, activePanel, setActivePanel, leaveLeftPanel, leaveTabs, noPadding = false}) {

    return (
      <div className='col-span-6 '>
            {
              !leaveTabs &&
              <div className=''>
              <Tabs tabs={tabs} activeTab={activeTab} setActiveTab={setActiveTab}/>
            </div>
            }
            
           {!leaveLeftPanel ? 
            <SubTemplate 
            leaveTabs={leaveTabs}
            assistantScreen={assistantScreen}
            content={content} 
            activeTab={activeTab}
            panelItems={panelItems}
            activePanel={activePanel}
            setActivePanel={setActivePanel}
            />
            :
            <div className={'rounded h-full relative w-full flex  rounded '+ (noPadding ? " px-6" : " ")}>
             {content}
            </div>
           }
      </div>
    )
}

export default Template;